import { PropTypes } from 'prop-types';
import React from 'react';
import ReactPaginate from 'react-paginate';

class ResourceList extends React.Component {
	render() {
		let innerContent = this.props.content;

		if (innerContent === '') {
			innerContent = '<div class="resource-collection-noresults"><p>No results found. Please change your filter options to try again.</p></div>';
		}

		let content = (
			<div
				className="resource-card-collection-wrapper"
				dangerouslySetInnerHTML={{ __html: innerContent }}
			/>
		);

		let afterListing = null;
		if (this.props.isLoading) {
			content = (
				<div className="resource-loading">
					<span className="resource-loading-text">Loading</span>
					<div className="resource-loading-throbber" />
				</div>
			);
		} else if (this.props.totalPages > 1) {
			afterListing = (
				<ReactPaginate
					previousLabel={'Previous'}
					nextLabel={'Next'}
					breakLabel={'…'}
					breakClassName={'break-me'}
					forcePage={this.props.page - 1}
					pageCount={this.props.totalPages}
					marginPagesDisplayed={2}
					pageRangeDisplayed={5}
					onPageChange={this.props.onClickPage}
					containerClassName={'resource-pagination'}
					subContainerClassName={'pages pagination'}
					activeClassName={'active'}
					hrefBuilder={n =>
						`${window.location.href.replace(
							/page(\/[0-9]*\/?)?$/i,
							''
						)}page/${n}/`
					}
				/>
			);
		}

		return (
			<div className="container">
				{content}
				{afterListing}
			</div>
		);
	}
}

ResourceList.propTypes = {
	isLoading: PropTypes.bool,
	content: PropTypes.string,
	page: PropTypes.number,
	totalPages: PropTypes.number,
	onClickPage: PropTypes.func
};

export default ResourceList;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/components/resource-list.js